// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3Ei22","col":"styles_col__3iY4c"};